import React from "react";

const Account = React.lazy(() => import("../pages/account"));
const AccountTodo = React.lazy(() => import("../pages/account/todo"));
const AccountActivity = React.lazy(() => import("../pages/account/activity"));
const Home = React.lazy(() => import("../pages/home"));
const Forgot = React.lazy(() => import("../pages/forgot"));
const Login = React.lazy(() => import("../pages/login"));
const Signup = React.lazy(() => import("../pages/signup"));
const ResetPasswordPage = React.lazy(() => import("../pages/reset-password"));
const Profile = React.lazy(() => import("../pages/profile"));
const ProfileEditPage = React.lazy(() => import("../pages/profile/edit"));
const FriendsPage = React.lazy(() => import("../pages/friends"));
const PostPage = React.lazy(() => import("../pages/post/PostPage"));
const Messages = React.lazy(() => import("../pages/messages"));
const MessageByUsername = React.lazy(() => import("../pages/messages/MessageByUsername"));
const Landing = React.lazy(() => import("../pages/landing"));
// Login removed — handled by marketing site, not the SPA
const ClanRedesignPage = React.lazy(() => import("../pages/clanRedesign"));
const CommercePage = React.lazy(() => import("../pages/commerce"));
const EventsAll = React.lazy(() => import("../pages/events/all"));
const EventView = React.lazy(() => import("../pages/events/view"));
const EventCalendar = React.lazy(() => import("../pages/events/calendar"));
const AddEvent = React.lazy(() => import("../pages/events/add"));
const Conference = React.lazy(() => import("../pages/conference"));
const CallPage = React.lazy(() => import("../pages/call"));
const FilesAll = React.lazy(() => import("../pages/files/all"));
const AddFile = React.lazy(() => import("../pages/files/add"));
const VideosAll = React.lazy(() => import("../pages/videos/all"));
const AddVideo = React.lazy(() => import("../pages/videos/add"));
const PollsAll = React.lazy(() => import("../pages/polls/all"));
const Mp3All = React.lazy(() => import("../pages/mp3/all"));
const AddMp3 = React.lazy(() => import("../pages/mp3/add"));
const SubclanMessagesList = React.lazy(() => import("../pages/subclanMessages/list"));
const SubclanMessagesCreate = React.lazy(() => import("../pages/subclanMessages/create"));
const UserCategoriesPage = React.lazy(() => import("../pages/userCategories"));
const SiteMembersPage = React.lazy(() => import("../pages/siteMembers"));
const InvitePage = React.lazy(() => import("../pages/invite"));
const Notifications = React.lazy(() => import("../pages/notifications"));
const Members = React.lazy(() => import("../pages/members"));
const ForumIndexPage = React.lazy(() => import("../pages/forum"));
const ForumTopicPage = React.lazy(() => import("../pages/forum/topic"));

const pagesData = [
  {
    path: "",
    element: <Landing />,
    title: "landing",
    priv: false,
  },
  {
    path: "login",
    element: <Login />,
    title: "login",
    priv: false,
  },
  {
    path: "signup",
    element: <Signup />,
    title: "signup",
    priv: false,
  },
  {
    path: "forgot",
    element: <Forgot />,
    title: "forgot",
    priv: false,
  },
  {
    path: "reset-password/:token",
    element: <ResetPasswordPage />,
    title: "reset-password",
    priv: false,
  },
  // The account area is one shell with several views (see
  // pages/account/AccountShell.jsx). Every item in the shared nav
  // (pages/account/accountNav.jsx) points at one of these, or at /profile and
  // /support below — no nav item links at a route that doesn't exist.
  {
    path: "account",
    element: <Account />,
    title: "account",
    priv: true,
  },
  {
    path: "account/todo",
    element: <AccountTodo />,
    title: "account-todo",
    priv: true,
  },
  {
    path: "account/activity",
    element: <AccountActivity />,
    title: "account-activity",
    priv: true,
  },
  {
    path: "home",
    element: <Home />,
    title: "home",
    priv: true,
  },
  {
    path: "search",
    element: <ClanRedesignPage surface="search" />,
    title: "search",
    priv: true,
  },
  {
    path: "activate/:token",
    element: <Home />,
    title: "activate",
    priv: true,
  },
  {
    path: "profile",
    element: <ClanRedesignPage surface="profile" />,
    title: "profile",
    priv: true,
  },
  {
    path: "usage",
    element: <ClanRedesignPage surface="usage" />,
    title: "usage",
    priv: true,
  },
  {
    path: "support",
    element: <ClanRedesignPage surface="support" />,
    title: "support",
    priv: true,
  },
  {
    path: "commerce",
    element: <CommercePage />,
    title: "commerce",
    priv: true,
  },
  {
    path: "commerce/:commerceSection",
    element: <CommercePage />,
    title: "commerce-section",
    priv: true,
  },
  {
    path: "u/:username",
    element: <Profile />,
    title: "profile",
    priv: true,
  },
  {
    path: "u/:username/edit",
    element: <ProfileEditPage />,
    title: "profile-edit",
    priv: true,
  },
  {
    path: "u/:username/:subpage",
    element: <Profile />,
    title: "profile-subpage",
    priv: true,
  },
  {
    path: "messages",
    element: <Messages />,
    title: "messages",
    priv: true,
  },
  {
    path: "messages/all",
    element: <Messages />,
    title: "messages-all",
    priv: true,
  },
  {
    path: "messages/:chatId",
    element: <Messages />,
    title: "messages",
    priv: true,
  },
  {
    path: "messages/message/:username",
    element: <MessageByUsername />,
    title: "messages-by-username",
    priv: true,
  },
  {
    path: "friends",
    element: <FriendsPage />,
    title: "profile",
    priv: true,
  },
  {
    path: "friends/:type",
    element: <FriendsPage />,
    title: "profile",
    priv: true,
  },
  {
    path: "profile/:username",
    element: <Profile />,
    title: "profile",
    priv: true,
  },
  {
    path: "u/:username/posts/:post",
    element: <PostPage />,
    title: "profile",
    priv: true,
  },
  {
    path: "post/:post",
    element: <PostPage />,
    title: "post",
    priv: true,
  },
  {
    path: "notifications",
    element: <Notifications />,
    title: "notifications",
    priv: true,
  },
  {
    path: "notifications/all",
    element: <Notifications />,
    title: "notifications-all",
    priv: true,
  },
  {
    path: "event/all",
    element: <EventsAll />,
    title: "events",
    priv: true,
  },
  {
    path: "event/list",
    element: <EventsAll />,
    title: "events-list",
    priv: true,
  },
  {
    path: "event/view/:guid",
    element: <EventView />,
    title: "event",
    priv: true,
  },
  {
    path: "event/view/:guid/:slug",
    element: <EventView />,
    title: "event-slug",
    priv: true,
  },
  {
    path: "event/calendar",
    element: <EventCalendar />,
    title: "event-calendar",
    priv: true,
  },
  {
    path: "event/my",
    element: <EventsAll />,
    title: "events-my",
    priv: true,
  },
  {
    path: "event/list/:userId",
    element: <EventsAll />,
    title: "events-user",
    priv: true,
  },
  {
    path: "event/add",
    element: <AddEvent />,
    title: "event-add",
    priv: true,
  },
  // Conference / Video Meeting
  {
    path: "conference/:eventId",
    element: <Conference />,
    title: "conference",
    priv: true,
  },
  // 1-on-1 Voice / Video Call
  {
    path: "call/:callId",
    element: <CallPage />,
    title: "call",
    priv: true,
  },
  {
    path: "members",
    element: <Members />,
    title: "members",
    priv: true,
  },
  // Files
  {
    path: "files/all",
    element: <FilesAll />,
    title: "files",
    priv: true,
  },
  {
    path: "files/my",
    element: <FilesAll />,
    title: "files-my",
    priv: true,
  },
  // NOTE: there is deliberately no `files/all/:userId` route (nor the
  // matching `video/list/user/:userId` / `mp3/all/:userId`). They were
  // carried over from the legacy sandbox URL space but the per-user listing
  // was never built: the API (contentController.new.js getFiles/getMp3s/
  // getVideos) accepts only `mine` and `q`, no owner filter, and nothing in
  // the app ever linked to them. Two of the three were worse than dead —
  // they sent `mine=true` and showed the viewer their OWN media under a URL
  // claiming another user's. Reinstate them together with a server-side
  // owner filter, not on their own.
  {
    path: "files/add",
    element: <AddFile />,
    title: "files-add",
    priv: true,
  },
  // Videos
  {
    path: "video/list/all",
    element: <VideosAll />,
    title: "videos",
    priv: true,
  },
  {
    path: "videos/my",
    element: <VideosAll />,
    title: "videos-my",
    priv: true,
  },
  {
    path: "video/add",
    element: <AddVideo />,
    title: "video-add",
    priv: true,
  },
  // Polls
  {
    path: "polls/list/all",
    element: <PollsAll />,
    title: "polls",
    priv: true,
  },
  {
    path: "polls/my",
    element: <PollsAll />,
    title: "polls-my",
    priv: true,
  },
  {
    path: "polls/list/:userId",
    element: <PollsAll />,
    title: "polls-user",
    priv: true,
  },
  // MP3 / Audios
  {
    path: "mp3/all",
    element: <Mp3All />,
    title: "mp3",
    priv: true,
  },
  {
    path: "mp3/my",
    element: <Mp3All />,
    title: "mp3-my",
    priv: true,
  },
  {
    path: "mp3/add",
    element: <AddMp3 />,
    title: "mp3-add",
    priv: true,
  },
  // Subclan Chat / Rooms
  {
    path: "subclan_messages/list",
    element: <SubclanMessagesList />,
    title: "subclan-messages",
    priv: true,
  },
  {
    path: "subclan_messages/member",
    element: <SubclanMessagesList />,
    title: "subclan-messages-member",
    priv: true,
  },
  {
    path: "subclan_messages/create",
    element: <SubclanMessagesCreate />,
    title: "subclan-messages-create",
    priv: true,
  },
  // User Categories
  {
    path: "users/:catId/:catName",
    element: <UserCategoriesPage />,
    title: "user-categories",
    priv: true,
  },
  // Site Members by Gender
  {
    path: "site_members/:gender",
    element: <SiteMembersPage />,
    title: "site-members-gender",
    priv: true,
  },
  // Invite Friends
  {
    path: "invite",
    element: <InvitePage />,
    title: "invite",
    priv: true,
  },
  {
    path: "forum",
    element: <ForumIndexPage />,
    title: "forum",
    priv: true,
  },
  {
    path: "forum/topics/:id",
    element: <ForumTopicPage />,
    title: "forum-topic",
    priv: true,
  },
  // NOTE: The /administrator routes are now handled by the new AdminLayout
  // in client/src/pages/admin/ with nested React Router routes.
  // See router.jsx for the admin route tree.
];

export default pagesData;
